var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnselectedYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54454_44995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6954 6.26102C50.3981 5.05079 49.818 3.94747 49.013 3.06095C48.208 2.17443 47.2061 1.53564 46.1072 1.20821C42.084 0 25.8934 0 25.8934 0C25.8934 0 9.70215 0.0366652 5.67955 1.24487C4.5807 1.57236 3.57892 2.21117 2.77396 3.09769C1.96901 3.9842 1.38898 5.08749 1.09162 6.29769C-0.125275 14.1702 -0.597385 26.1653 1.12491 33.7226C1.42227 34.9328 2.0023 36.0361 2.80726 36.9226C3.61221 37.8091 4.61399 38.4479 5.71284 38.7754C9.73575 39.9836 25.9267 39.9836 25.9267 39.9836C25.9267 39.9836 42.1176 39.9836 46.1405 38.7754C47.2393 38.4479 48.2411 37.8091 49.0461 36.9226C49.851 36.0361 50.4311 34.9328 50.7284 33.7226C52.0116 25.8392 52.4073 13.8514 50.6951 6.26137L50.6954 6.26102Z",
    fill: "#7C757E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7402 28.5598L34.1717 19.992L20.7402 11.4238V28.5598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54454_44995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedYoutube);
export default __webpack_public_path__ + "static/media/unselectedYoutube.d3be1abd485ed312e20f0b7aec901767.svg";
export { ForwardRef as ReactComponent };